import styled from 'styled-components';

export const Container = styled.div`
    max-width: 940px;
    margin: 18px auto 0;
    position: relative;
    user-select: none;
    margin-bottom: 60px;
`;
